import { GraphQLUnionType } from 'graphql';

import CourseType from './course.gql.js';
import CurriculumType from './curriculum.gql.js';

const CourseCurriculumUnionType = new GraphQLUnionType({
  name: 'CourseCurriculumUnionType',
  types: [CourseType, CurriculumType],
  resolveType: (data) => {
    switch (data.constructor.name) {
      case 'Course':
        return CourseType;
      case 'Curriculum':
        return CurriculumType;
      default:
        return CourseType;
    }
  }
});

export default CourseCurriculumUnionType;
